import React, { useState } from 'react'
import Modal from '@/v2/components/common/Modal'
import PatientForm from '@/v2/components/forms/Patient/Form'
import validator from '@/v2/components/forms/Patient/validator'
import fromForm from '@/v2/components/forms/Patient/fromForm'
import { useSnackbarContext } from '@/v2/contexts/SnackbarContext'
import { useUpdateConversation } from '@/v2/hooks/messages/useConversations'
import { errorsFromJson } from '@/v2/utils/forms'
import { formatPhone } from '@/v2/utils/format'
import usePatient from '@/v2/hooks/usePatient/usePatient'

const NewPatient = ({ phone, conversationId, isOpen, onClose }) => {
  const [patient, setPatient] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: phone ? formatPhone(phone) : '',
    heardFrom: '',
  })
  const [error, setError] = useState({})
  const { createPatient } = usePatient({ patientId: null })
  const { updateConversation } = useUpdateConversation(conversationId)
  const { onOpenSnackbar } = useSnackbarContext()

  const handleCreatePatient = async () => {
    try {
      const response = await createPatient(fromForm(patient))
      const asyncErrors = errorsFromJson(response.errors)

      if (asyncErrors) {
        const { phoneNumber, ...others } = asyncErrors
        setError({ phone: phoneNumber, ...others })
        onOpenSnackbar(
          'Unable to create patient. Please check the form and try again.',
          'error'
        )
        return
      }

      onOpenSnackbar('Patient created.')

      await updateConversation({
        patientId: response.id,
      })

      onClose()
    } catch (err) {
      setError({ general: 'Failed to create patient' })
      onOpenSnackbar('Failed to create patient. Please try again.', 'error')
    }
  }

  const handleSubmit = () => {
    const validErrors = validator(patient)
    setError(validErrors || {})

    if (!validErrors) {
      handleCreatePatient()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      title="New Patient"
      confirmLabel="Create"
      cancelLabel="Cancel"
      onConfirm={handleSubmit}
      onClose={onClose}
    >
      <PatientForm
        values={patient}
        error={error}
        onChange={values => setPatient({ ...patient, ...values })}
      />
    </Modal>
  )
}

export default NewPatient
